var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { serialize } from '../../../utils/serializr/core/serialize';
export class QuestionStrip {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get question() {
        return this.parent;
    }
    appJson_cached = '';
    //  strippedOnce: boolean = false;
    get stripped() {
        if (this.question.isCurrentEditQuestion) {
            //  && !this.strippedOnce
            const value = serialize(this.question, this.question.constructor.stripInfo);
            this.appJson_cached = value;
            //  this.strippedOnce = true;
            return value;
        }
        return this.appJson_cached;
    }
    set stripped(j) {
        this.appJson_cached = j;
    }
}
__decorate([
    computed.struct
], QuestionStrip.prototype, "stripped", null);
